module.exports = __webpack_public_path__ + "img/bg.0e52b27c.png";